var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"modal",attrs:{"id":"myModal"},on:{"click":_vm.close}},[_c('span',{staticClass:"close"},[_vm._v("×")]),_c('img',{staticClass:"modal-content",attrs:{"src":_vm.image},on:{"click":function($event){$event.stopPropagation();}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }